import { shape, number, string, bool, object, array, arrayOf, func } from 'prop-types';
import { momentObj } from 'react-moment-proptypes';

export const unNumberType = shape({
  id: object,
  unNumber: number,
  dangerCode: string,
  createUser: object,
  createDte: momentObj,
  delUser: object,
  delDte: momentObj
});

export const inventoryType = shape({
  id: number,
  location: object,
  preciseLocation: string,
  technicalEquipment: string,
  asset: object,
  equipmentReference: string,
  contacts: array,
  chemicalName: string,
  tradeName: string,
  chemicalState: string,
  quantity: number,
  unNumber: string, //unNumberType
  casNumber: string,
  cmrClass: string,
  vlep: string,
  exposureMeasurement: string,
  hazards: array,
  documentNumber: string,
  checkDte: momentObj,
  edmsId: number
});

export const initialDataType = shape({
  inventory: inventoryType,
  hazardList: array,
  hazardTypeList: array,
  // unNumberList: array,
  // locationList: array,
  stateList: array
  // equipmentList: array
});

export const userType = shape({
  authenticated: bool,
  authorities: arrayOf(shape({ authority: string })),
  credentials: string,
  details: shape({}),
  name: string,
  principal: string,
  department: array
});

export const jobsInstanceType = shape({
  startTime: string,
  endTime: string
});

export const jobsStateType = shape({
  isLoading: shape({
    jobAction: bool,
    jobs: bool
  }),
  errors: shape({}),
  data: shape({
    jobs: arrayOf(jobsInstanceType).isRequired
  }),
  actions: shape({
    getJob: func.isRequired,
    startJob: func.isRequired,
    pauseJob: func.isRequired
  })
});

export const filterFieldType = shape({
  label: string.isRequired,
  key: string.isRequired,
  value: string.isRequired,
  filterType: shape({
    type: string.isRequired,
    options: array
  })
});

export const visibleColumnType = filterFieldType;

export const filterPropsType = shape({
  possibleFieldsList: array.isRequired,
  visibleFieldsList: array.isRequired,
  possibleColumnsList: array.isRequired,
  visibleColumnsList: array.isRequired,
  filteredList: shape({
    result: array.isRequired,
    totalPages: number.isRequired,
    totalElements: number.isRequired
  }),
  isLoading: bool.isRequired
});

export const filterStateType = shape({
  page: number.isRequired,
  visibleColumnsList: visibleColumnType,
  sort: shape({ sortField: string, sortDirection: string }),
  pageSize: number,
  highlightedElementId: number
});
